export default {"src":"/_next/static/media/info.3fefa899.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};